<template>
  <div>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" lg="8" offset-lg="2" xl="8" offset-xl="2">
        <v-card flat align="center" class="mb-10 pa-4">
          <v-card-text>
            <v-icon x-large color="greenb">mdi-check</v-icon>
            <h2 class="h2 my-4 greend--text">
              Vielen Dank für Ihre Bestellung
            </h2>
            Wir senden Ihnen zeitnah eine Bestätigung per E-Mail.<br />
          </v-card-text>
          <v-card-actions class="mt-6">
            <v-spacer />
            <v-btn small text color="greenb" to="/">
              Zurück zur Startseite
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols="12" lg="8" offset-lg="2" xl="8" offset-xl="2">
        <v-card outlined align="center" class="mb-10 pa-4 red" elevation="5">
          <v-card-text class="white--text">
            <v-icon x-large color="white">mdi-alert-circle</v-icon>
            <h2 class="h2 my-4 white--text">
              HINWEIS
            </h2>
            Diese Webseite ist noch im Test-Modus, die Bestellung wird nicht
            verarbeitet!
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.state.cart = [];
  }
};
</script>
